<template>
    <nav class="navbar navbar-fixed navbar-expand-lg" id="main-navbar">
        <!-- ================= MOBILE HEADER ================= -->
        <div class="d-flex d-lg-none flex-column align-items-center w-100 px-2 pt-1">

            <div class="d-flex align-items-center justify-content-between w-100">
                <router-link to="/home" class="d-flex align-items-center">
                    <img :src="getAbsoluteImageUrl('/img/logo/app.webp')"
                        alt="PRESSA Promotora Especializada en Soportes SA de CV " class="logo-img img-fluid"
                        style="max-height: 40px;" />
                </router-link>

                <div class="d-flex align-items-center">
                    <button class="btn p-0" data-bs-toggle="offcanvas" data-bs-target="#offcanvasDarkNavbar"
                        style="color: white;">
                        <i class="bx bx-menu"></i>
                    </button>

                    <span class="icon-divider">|</span>

                    <button class="btn p-0">
                        <BusquedaAvanzada2 />
                    </button>

                    <span class="icon-divider">|</span>
                    <div v-if="isLoggedin" class="d-flex align-items-center gap-2">
                        <div
                            v-if="permissions_auth.includes('permission_compras') && !rol_auth.includes('Cotizador-Mostrador')">
                            <router-link :to="{ name: 'CartItemsList' }" class="btn position-relative p-1"
                                style="color:white;">
                                <i class="bx bxs-cart-alt fs-2"></i>
                                <span class="position-absolute badge rounded-pill bg-warning"
                                    style="font-size: 11px; top: 0; right: 0;">
                                    {{ obtenerCantidadEnCarrito }}
                                </span>
                            </router-link>
                        </div>
                    </div>

                    <span v-if="isLoggedin" class="icon-divider">|</span>
                    <div>
                        <MenuUser v-if="isLoggedin" :cliente="cliente_auth" :rol_auth="rol_auth"
                            :permissions_auth="permissions_auth" @logout="logout" />

                        <router-link v-else to="/Ingresa" class="btn btn-login d-flex align-items-center"
                            style="color: white;">
                            <i class="bx bx-log-in me-2"></i>
                            <span class="d-none d-sm-inline">Ingresar</span>
                        </router-link>
                    </div>
                </div>
            </div>

            <!-- SEGUNDO RENGLÓN MÓVIL -->
            <div class="w-100 mt-2 px-1 position-relative">
                <!-- Añadido position-relative para acoplar la lista flotante -->
                <div class="input-group buscador-elegante w-100">

                    <button class="btn btn-outline-light dropdown-toggle" type="button" data-bs-toggle="dropdown"
                        aria-expanded="false" style="background-color: rgba(255,255,255,0.1); font-size: 13px;">
                        <i class="bx bx-filter-alt me-1"></i> {{ tipoBusquedaActual }}
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="#" @click.prevent="cambiarTipoBusqueda('General')"><i
                                    class="bx bx-globe me-2"></i>General</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="cambiarTipoBusqueda('Clave')"><i
                                    class="bx bx-key me-2"></i>Clave</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="cambiarTipoBusqueda('Alterna')"><i
                                    class="bx bx-git-compare me-2"></i>Alterna</a></li>
                    </ul>

                    <input class="form-control buscador-input" type="search" :placeholder="placeholderDinamico"
                        aria-label="Search" @input="handleSearchInputDebounced" @keyup.enter="busquedaEnter"
                        @blur="hideResults" @search="busquedaEnter" autocomplete="off" v-model="inputValue">

                    <span class="input-group-text buscador-icon">
                        <i v-if="!searching" class="fa fa-search"></i>
                        <div v-else class="spinner-border spinner-border-sm"></div>
                    </span>
                </div>

                <!-- ================= SOLUCIÓN MÓVIL: CONTENEDOR DE RESULTADOS REPLICADO ================= -->
                <div v-if="menuproductos" class="category-list2 position-absolute w-100 bg-white shadow rounded border"
                    style="top: 100%; left: 0; z-index: 1050; max-height: 350px; overflow-y: auto;">

                    <div v-if="showNoResults" class="p-3 text-center text-muted">
                        No encontramos resultados para "<strong>{{ inputValue }}</strong>"
                    </div>

                    <div v-else>
                        <div class="column" v-if="resultados.length > 0">
                            <div class="group-header p-2 border-b">
                                &nbsp;<span class="badge text-bg-info text-white"><i
                                        class="fas fa-tag"></i></span>&nbsp;
                                <span style="color: #333; font-size:14px;">Sugeridos ({{ tipoBusquedaActual }}):</span>
                            </div>
                            <ul class="list-unstyled mb-0">
                                <li v-for="resultado in resultados" :key="resultado.id" class="p-2 border-bottom">
                                    <div class="nav-link2 d-flex flex-column align-items-start"
                                        @mousedown.prevent="handleResultClick(resultado)" style="cursor: pointer;">
                                        <div class="d-flex flex-wrap align-items-center w-100">
                                            <h6 class="ms-2 mb-0" style="font-size: 14px; color: #06283c;">{{
                                                resultado.k_parte }}</h6>
                                            <div class="d-flex flex-wrap align-items-center ms-auto gap-1">
                                                <span class="badge bg-success" style="font-size: 9px;"
                                                    v-if="resultado.badgenuevo">Nuevo</span>
                                                <span class="badge-vino-fino" style="font-size: 9px;"
                                                    v-if="resultado.especial && resultado.especial !== 'False' && resultado.especial !== 'false'">
                                                    <i class="bx bx-crown"></i> Recom.
                                                </span>
                                                <span class="badge-vino-naranja" style="font-size: 9px;"
                                                    v-if="resultado.mejoresventas">
                                                    <i class="bx bx-award"></i> Top
                                                </span>
                                            </div>
                                        </div>
                                        <span class="ms-2 text-muted extra-small" style="font-size: 11px;">{{
                                            resultado.linea }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- =================================================================================== -->
            </div>
        </div>

        <!-- ================= DESKTOP HEADER ================= -->
        <div class="d-none d-lg-flex align-items-center justify-content-between w-100 px-2">
            <div class="container-fluid d-block p-0">
                <div class="row w-100 align-items-center flex-nowrap g-0">
                    <div class="col-lg-1 col-5 text-center">
                        <router-link class="navbar-brand m-0" to="/home">
                            <img :src="getAbsoluteImageUrl('/img/logo/app.webp')"
                                alt="PRESSA Promotora Especializada en Soportes SA de CV " class="logo-img img-fluid"
                                :class="showSecondRow ? 'logo-img-smaller' : 'logo-img'">
                        </router-link>
                    </div>
                    <div class="col-lg-auto d-none d-lg-flex align-items-center justify-content-center p-0">
                        <BusquedaAvanzada2 />
                    </div>
                    <div class="col-lg d-none d-lg-flex buscador-radio-personalizado">
                        <div class="input-group buscador-elegante w-100 position-relative">

                            <button class="btn btn-outline-secondary dropdown-toggle text-white" type="button"
                                data-bs-toggle="dropdown" aria-expanded="false"
                                style="border-color: rgba(255,255,255,0.2);">
                                <i class="bx bx-filter-alt me-1"></i> {{ tipoBusquedaActual }}
                            </button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#" @click.prevent="cambiarTipoBusqueda('General')"><i
                                            class="bx bx-globe me-2"></i>General</a></li>
                                <li><a class="dropdown-item" href="#" @click.prevent="cambiarTipoBusqueda('Clave')"><i
                                            class="bx bx-key me-2"></i>Clave</a></li>
                                <li><a class="dropdown-item" href="#" @click.prevent="cambiarTipoBusqueda('Alterna')"><i
                                            class="bx bx-git-compare me-2"></i>Alterna</a></li>
                            </ul>

                            <input class="form-control buscador-input" type="search" ref="searchInput"
                                :placeholder="placeholderDinamico" @input="handleSearchInputDebounced"
                                @keyup.enter="busquedaEnter" @blur="hideResults" autocomplete="off"
                                @search="busquedaEnter($event)" v-model="inputValue">

                            <span class="input-group-text buscador-icon">
                                <i v-if="!searching" class="fa fa-search"></i>
                                <div v-else class="spinner-border spinner-border-sm"></div>
                            </span>
                            <span class="input-group-text microfono" :class="{ active: isListeningVoice }"
                                @click="startVoiceRecognition">
                                <i class="fa fa-microphone"></i>
                            </span>

                            <div v-if="menuproductos"
                                class="category-list2 position-absolute w-100 bg-white shadow rounded border"
                                style="top: 100%; left: 0; z-index: 1000;">

                                <div v-if="showNoResults" class="p-3 text-center text-muted">
                                    No encontramos resultados para "<strong>{{ inputValue }}</strong>"
                                </div>

                                <div v-else>
                                    <div class="column" v-if="resultados.length > 0">
                                        <div class="group-header">
                                            &nbsp;<span class="badge text-bg-info text-white"><i
                                                    class="fas fa-tag"></i></span>&nbsp;
                                            <span style="color: #333;font-size:16px;">Sugeridos ({{ tipoBusquedaActual
                                            }}): </span>
                                        </div>
                                        <ul class="list-unstyled">
                                            <li v-for="resultado in resultados" :key="resultado.id" class="p-2">
                                                <div class="nav-link2 d-flex flex-column align-items-start"
                                                    @mousedown.prevent="handleResultClick(resultado)"
                                                    style="cursor: pointer;">
                                                    <div class="d-flex align-items-center">
                                                        <h6 class="ms-2 mb-0">{{ resultado.k_parte }}</h6>
                                                        <div class="d-flex align-items-center ms-2">
                                                            <span class="badge bg-success me-2"
                                                                v-if="resultado.badgenuevo">Nuevo</span>
                                                            <span class="badge-vino-fino" style="font-size: 10px;"
                                                                v-if="resultado.especial && resultado.especial !== 'False' && resultado.especial !== 'false'">
                                                                <i class="bx bx-crown" aria-hidden="true"></i>
                                                                Recomendación para ti
                                                            </span>
                                                            <span class="badge-vino-naranja" style="font-size: 10px;"
                                                                v-if="resultado.mejoresventas">
                                                                <i class="bx bx-award" aria-hidden="true"></i>&nbsp;Top
                                                                Ventas
                                                            </span>
                                                            <span class="badge-vino-azul" style="font-size: 10px;"
                                                                v-else-if="resultado.mejoresventaslineas">
                                                                <i class="bx bx-star" aria-hidden="true"></i>&nbsp;Top
                                                                Ventas Lineas
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <span class="ms-2 text-muted small">{{ resultado.linea }}</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto d-block d-lg-none ms-auto">
                        <button class="btn p-0" data-bs-toggle="modal" data-bs-target="#openAdvancedSearchModalButton"
                            style="color: white; font-size: 24px;">
                            <i class="bx bx-search"></i>
                        </button>
                    </div>

                    <div class="col-lg-1 col-auto ms-auto d-flex justify-content-end align-items-center">
                        <div v-if="isLoggedin" class="d-flex align-items-center gap-2">
                            <div
                                v-if="permissions_auth.includes('permission_compras') && !rol_auth.includes('Cotizador-Mostrador')">
                                <router-link :to="{ name: 'CartItemsList' }" class="btn position-relative p-1"
                                    style="color:white;">
                                    <i class="bx bxs-cart-alt fs-2"></i>
                                    <span class="position-absolute badge rounded-pill bg-warning"
                                        style="font-size: 11px; top: 0; right: 0;">
                                        {{ obtenerCantidadEnCarrito }}
                                    </span>
                                </router-link>
                            </div>
                            <MenuUser :cliente="cliente_auth" :rol_auth="rol_auth" :permissions_auth="permissions_auth"
                                :name="namecliente_auth" @logout="logout" />
                        </div>

                        <router-link v-else to="/Ingresa" class="btn btn-login btn-sm d-flex align-items-center"
                            style="color: white;">
                            <i class="bx bx-log-in me-1"></i> Ingresar
                        </router-link>
                    </div>
                </div>
                <div class="row w-100">
                    <div class="col-12">
                        <Navigation :isLargeScreen="isLargeScreen" :showLevel2="showLevel2"
                            :submenuOpenNavegacion="submenuOpenNavegacion" @toggle-submenu="toggleSubmenuNavegacion" />
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasDarkNavbar"
        aria-labelledby="offcanvasDarkNavbarLabel"
        style="background-color: rgba(6, 40, 60, 0.90)!important; width: 80vw; max-width: 320px; top: var(--navbar-height, 90px);">
        <!-- Explicación: width: 80vw le dice que use el 80% de la pantalla táctil, max-width asegura que en tablets no se estire demasiado -->

        <div class="offcanvas-header">
            <h5 id="offcanvasDarkNavbarLabel" class="text-light">Menú</h5>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <ul class="navbar-nav my-2 my-lg-0 navbar-nav-scroll">
                <li class="nav-item">
                    <router-link to="/Home" class="nav-link active menuitem">
                        <span>Home</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/contacto" class="nav-link active menuitem">
                        <span>Contacto</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/ListBlogs" class="nav-link active menuitem">
                        <span>Blog</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/ProdsMX" class="nav-link active menuitem">
                        <span>Hecho en México</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/OurBrands" class="nav-link active menuitem">
                        <span>Nuestras Marcas</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { debounce } from 'lodash';
import { Offcanvas } from 'bootstrap';
import BusquedaAvanzada2 from './Components/busquedaavanzada.vue';
import Navigation from './Components/menunavegation.vue';
import MenuUser from './Components/Usermenu.vue';

export default {
    components: {
        BusquedaAvanzada2,
        Navigation,
        MenuUser
    },
    data() {
        return {
            isLoggedin: window.Laravel.isLoggedin,
            cliente_auth: window.Laravel.user ? window.Laravel.user.id : '',
            namecliente_auth: window.Laravel.user ? window.Laravel.user.name : '',
            rol_auth: window.Laravel.roles,
            permissions_auth: window.Laravel.permissions_auth,
            isLargeScreen: window.innerWidth >= 768,
            showList: false,
            searchExpanded: false,
            searching: false,
            inputValue: '',
            nav2: false,
            showSecondRow: false,
            showText: false,
            lineasBsuqe: '',
            lineasDispo: '',
            resultados: [],
            resultados2: [],
            isMenuOpen: false,
            showProducts: false,
            showUsers: false,
            showPedidos: false,
            isSubMenuOpen: false,
            menuproductos: false,
            sidebarOpenRespo: false,
            showSearchInput: false,
            isExpandedFooter: false,
            isMenuOpenRespo: false,
            showErrors: false,
            selectedYear: '',
            selectedMonth: '',
            showCaptcha: false,
            recaptchaToken: null,
            isOpen: false,
            activeSubMenu: null,
            queryVoz: "",          // Almacena el texto de la búsqueda
            recognition: null,  // Controla el reconocimiento de voz
            isListeningVoice: false,
            sucursalesDataPrincipal: {
                redes: [] // Evita que sea null o undefined
            },
            tipoBusqueda: 1, // Valor inicial
            tipoBusquedaActual: 'General',
            isSubMenuVisibleD: false,
            inputValue2: '',
            searching2: false,
            resultadosResponsivos: [],
            showLevel2: true,
            lastScroll: 0,
            submenuIndicadores: false,
            submenuOpenNavegacion: false,
            toast: {
                visible: false,
                data: null
            },
            showNoResults: false,
            searchRequestId: 0,
            searchAbortController: null,
        }
    },
    created() {
        window.addEventListener('resize', this.checkScreenSize);
        window.addEventListener("scroll", this.handleScroll);
        this.handleSearchInputDebounced = debounce(this.handleSearchInput, 100);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
        window.removeEventListener("scroll", this.handleScroll);
        document.removeEventListener('click', this.closeSearchResults);
        if (this.cliente_auth) {
            // Usa el nombre exacto del canal al que te suscribiste en mounted()
            Echo.leave(`App.Models.User.${this.cliente_auth}`);
        }
    },
    mounted() {
        this.enfocarBuscador();
        this.$store.dispatch('obtenerCantidadEnCarrito');
        if (!this.cliente_auth) return;
    },
    watch: {
        // Se ejecuta CADA VEZ que la URL / ruta cambia
        $route() {
            this.enfocarBuscador();
        }
    },
    computed: {
        obtenerCantidadEnCarrito() {
            return this.$store.getters.obtenerCantidadEnCarrito;
        },
        placeholderDinamico() {
            if (this.tipoBusquedaActual === 'Clave') {
                return 'Buscar estrictamente por código o clave de parte...';
            } else if (this.tipoBusquedaActual === 'Alterna') {
                return 'Buscar por códigos alternos o equivalencias...';
            }
            return 'Buscar por marca, modelo, año, código de parte, línea...';
        }
    },

    methods: {
        enfocarBuscador() {
            this.$nextTick(() => {
                // El '?' (optional chaining) evita errores si por alguna razón el ref es null
                this.$refs.searchInput?.focus();
            });
        },
        cambiarTipoBusqueda(tipo) {
            this.tipoBusquedaActual = tipo;

            // Opcional: Disparar la búsqueda automáticamente si ya hay algo escrito
            if (this.inputValue) {
                this.handleSearchInputDebounced();
            }
        },
        toggleSubmenuNavegacion() {
            this.submenuOpenNavegacion = !this.submenuOpenNavegacion;
        },
        checkScreenSize() {
            this.isLargeScreen = window.innerWidth >= 768;
        },
        hidePlaceholder() {
            this.inputValue2 = ''; // Borra el placeholder al hacer focus
            this.menuproductos = true;
        },
        showPlaceholder() {
            if (!this.inputValue2) {
                this.inputValue2 = ''; // Muestra el placeholder si está vacío
                this.menuproductos = false;
            }

        },
        showSubMenu() {
            this.isSubMenuVisibleD = true; // Muestra el submenú al pasar el mouse
        },
        hideSubMenu() {
            this.isSubMenuVisibleD = false; // Oculta el submenú al dejar de pasar el mouse
        },
        toggleMenuNuevo() {
            this.isOpen = !this.isOpen;
        },
        toggleSubMenu(name) {
            this.activeSubMenu = this.activeSubMenu === name ? null : name;
        },
        handleSubItemClick() {
            this.isOpen = false;
            this.activeSubMenu = null;
        },
        getLoginUrl() {
            //return '/Ingresa';
            window.location.href = `${window.location.origin}/Ingresa`;
        },
        toggleMenuResponsive() {
            this.sidebarOpenRespo = !this.sidebarOpenRespo;
        },
        toggleExpandedFooter() {
            this.isExpandedFooter = !this.isExpandedFooter; // Cambia el estado de expansión
        },
        handleDashboardClick() {
            // Aquí puedes realizar la acción que desees al hacer clic en el enlace
            this.isMenuOpen = false,
                this.showProducts = false,
                this.showUsers = false,
                this.isSubMenuOpen = false
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        getAbsoluteImageUrl(relativeUrl) {
            // Obtén la URL base de Laravel
            const baseUrl = window.location.origin;

            // Concatena la URL base con la ruta relativa de la imagen
            return baseUrl + relativeUrl;
        },
        toggleList2() {
            // Cambiar el estado de showList al hacer clic en el botón
            this.nav2 = !this.nav2;


            // Otros cambios que quieras hacer al hacer clic en el botón
        },
        toggleList() {
            this.showList = !this.showList;
        },
        closeList() {
            this.$store.dispatch('resetConsulta');
            this.showList = false;
        },
        async handleSearchInput() {
            // Cancela cualquier petición de búsqueda anterior que siga en vuelo
            if (this.searchAbortController) {
                this.searchAbortController.cancel('Nueva búsqueda iniciada');
            }
            this.searchAbortController = axios.CancelToken.source();

            const requestId = ++this.searchRequestId;
            this.searching = true;
            this.showNoResults = false;
            const tipoFiltro = this.tipoBusquedaActual.toLowerCase();

            try {
                if (this.inputValue.length >= 3) {
                    const response = await axios.get(`/search/${this.inputValue}`, {
                        params: { tipo: tipoFiltro },
                        cancelToken: this.searchAbortController.token
                    });
                    if (requestId !== this.searchRequestId) return;
                    const data = response.data?.data || response.data || [];
                    this.resultados = data;
                    this.resultados2 = data;
                    this.menuproductos = true;
                    this.showNoResults = data.length === 0;
                } else {
                    this.resultados = [];
                    this.showNoResults = false;
                    this.menuproductos = false;
                }
            } catch (error) {
                if (axios.isCancel(error)) {
                    // Fue cancelada a propósito, no es un error real
                    return;
                }
                if (requestId !== this.searchRequestId) return;
                console.error(error);
                this.resultados = [];
                this.showNoResults = true;
                this.menuproductos = true;
            } finally {
                if (requestId === this.searchRequestId) {
                    this.searching = false;
                }
            }
        },

        clearSearchText() {
            this.inputValue = ''; // Borrar el texto del input
            this.resultados = [];

        },
        /*handleScroll() {
            // Lógica para mostrar/ocultar la segunda fila según el scroll
            if (window.scrollY > 100) {
                this.showSecondRow = true;
            } else {
                this.showSecondRow = false;
            }
        },*/
        hideResults() {
            // Ocultar resultados solo si ni el input ni los resultados están siendo enfocados
            if (!this.inputFocused && !this.resultsFocused) {
                this.menuproductos = false;
            }
        },
        async busquedaEnter() {
            this.searchRequestId++;
            const prods = this.inputValue.trim();
            if (prods.length < 3) return;

            this.$store.dispatch('resetConsultaEnter');
            this.handleSearchInputDebounced.cancel();

            // Cancela cualquier búsqueda en curso — ya no necesitamos esperarla
            if (this.searchAbortController) {
                this.searchAbortController.cancel('Búsqueda con Enter');
            }
            this.searching = false;

            this.menuproductos = false;
            this.resultados = [];
            this.masbuscados = [];
            this.inputValue = '';
            document.activeElement?.blur();
            this.$router.push({
                name: 'BusquedaProductos',
                query: {
                    productobusqueda: prods,
                    tipobusqueda: this.tipoBusquedaActual.toLowerCase()
                }
            });
        },

        handleItemClick() {
            this.inputValue = '';
            this.resultados = [];
        },
        ajusteclick() {

            // Ejecutar acciones solo si no se hizo clic en un <router-link>
            this.searchExpanded = false;
            this.inputValue = '';
            this.resultados = [];

        },
        closeSearchResults(event) {
            // Verificar si se hizo clic dentro del área del input de búsqueda o en la lista de resultados
            const searchInput = document.getElementById('inputsearch');
            const searchResults = document.getElementById('divresultados');
            if (searchInput.contains(event.target) || searchResults.contains(event.target)) {
                return;
            }

            // Si se hizo clic fuera del área del input de búsqueda y de los resultados de búsqueda, cerrar la lista de resultados
            this.inputValue = '';
            this.resultados = [];
            // Aquí puedes agregar otras acciones si es necesario
        },
        logout() {
            axios.post(`${window.location.origin}/logout`)
                .then(() => {
                    // Limpieza centralizada en Vuex
                    this.$store.dispatch('clearGarageOperativo');

                    // Redirección
                    window.location.href = `${window.location.origin}/home`;
                })
                .catch(error => {
                    console.error('Error al hacer logout', error);
                });
        },
        handleBlur() {
            this.menuproductos = false
            this.isSearching = false
            this.searchExpanded = false
        },
        toggleSidebarRespo() {
            this.sidebarOpenRespo = !this.sidebarOpenRespo;
        }, toggleSearchInput() {
            this.showSearchInput = !this.showSearchInput;
        },
        verProducto(id) {
            // Realiza cualquier lógica adicional aquí, si es necesario
            // Por ejemplo, puedes validar algo antes de navegar a la página del producto

            // Luego, navega a la página del producto utilizando router.push()
            this.$router.push({ name: 'detalleProducto', query: { codigo: id } });
            this.menuproductos = false
        },
        handleResultClick(resultado) {
            // Vaciar el valor del input
            this.inputValue = '';
            this.searchExpanded = false;
            // Limpiar los resultados de búsqueda
            this.resultados = [];
            this.resultadosResponsivos = [];
            // Cerrar el menú de productos
            this.menuproductos = false;
            // Llamar a la función verProducto
            $('#openAdvancedSearchModalButton').modal('hide');
            this.verProducto(resultado.k_parte);
        },
        startVoiceRecognition() {
            // Verificar si el navegador soporta la Web Speech API
            if (!('webkitSpeechRecognition' in window)) {
                this.error = "Tu navegador no soporta búsqueda por voz.";
                return;
            }

            // Inicializar el reconocimiento de voz
            this.recognition = new webkitSpeechRecognition();
            this.recognition.lang = "es-MX"; // Configura el idioma
            this.recognition.continuous = false; // No escucha continuamente
            this.recognition.interimResults = false; // No resultados intermedios

            // Evento cuando se recibe un resultado
            this.recognition.onresult = (event) => {
                this.queryVoz = event.results[0][0].transcript; // Captura el texto de la voz
                this.error = null; // Limpia errores previos
                this.isListeningVoice = false;
                this.$router.push({ name: 'BusquedaProductos', query: { productobusqueda: this.queryVoz, tipobusqueda: this.tipoBusquedaActual.toLowerCase() } });
            };

            // Manejo de errores
            this.recognition.onerror = (event) => {
                console.error("Error en reconocimiento de voz:", event);
                if (event.error === "not-allowed") {
                    this.error = "Permiso denegado. Activa el micrófono en tu navegador.";
                } else {
                    this.error = "Ocurrió un error al procesar tu voz.";
                }
                this.isListeningVoice = false;
            };

            // Iniciar el reconocimiento de voz
            this.isListeningVoice = true;
            this.recognition.start();
        },
        getImageUrl(item) {
            try {
                // Verifica si item.PicturesUrl existe y tiene contenido
                if (!item.PicturesUrl || Object.keys(item.PicturesUrl).length === 0) {
                    return null;
                }

                // Intenta obtener la clave correcta basada en la categoría/marca
                let index = item.categorias[0]?.marcas?.viewimagesprinc ?? 4;

                // Manejo de los dos posibles formatos (con "0" o sin él)
                let imagenObj = item.PicturesUrl["0"]?.stdClass ?? item.PicturesUrl.stdClass;

                return imagenObj?.sm || null;
            } catch (error) {
                console.error("Error obteniendo la imagen:", error);
                return null;
            }
        },
        handleScroll() {
            const currentScroll = window.scrollY;
            if (currentScroll > this.lastScroll) {
                // Scroll hacia abajo
                this.showLevel2 = false;
            } else {
                // Scroll hacia arriba
                this.showLevel2 = true;
            }
            this.lastScroll = currentScroll;
        },
        cerrarOffcanvas() {
            const offcanvasElement = document.getElementById('offcanvasDarkNavbar')
            const offcanvasInstance = Offcanvas.getInstance(offcanvasElement)

            if (offcanvasInstance) {
                offcanvasInstance.hide()
            }
        }
    }
}
</script>
<style scoped>
.buscador-elegante {
    border-radius: 12px;
    overflow: visible;
    /* IMPORTANT */
}

/* Dropdown */
.buscador-dropdown {
    background: #003666;
    color: white;
    border: none;
    min-width: 100px;
    white-space: nowrap;
}

.buscador-dropdown:hover {
    background: #004b8f;
    color: white;
}

.buscador-input {
    border: none;
    padding-left: 12px;
}

.buscador-input:focus {
    box-shadow: none !important;
}

.buscador-icon {
    background: white;
    cursor: pointer;
    border-left: none;
}

.microfono {
    background: white;
    cursor: pointer;
    border-left: none;
    transition: 0.2s;
}

.microfono.active {
    background: #e0f0ff;
    color: #0066cc;
}

.icon-divider {
    color: rgba(0, 54, 102, 0.8);
    /* 0.8 es la opacidad, ajusta a tu gusto */
    margin: 0 10px;
    font-weight: 300;
    font-size: 18px;
    user-select: none;
}
</style>